import React from "react";
import { GridRow, GridColumn, LabeledText } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../common/types/Language";
import { ensureAudioFileRecordDetails, FileRecordDetails } from "../FileRecordDetails";

interface AudioFileRecordLanguagesViewProps {
    fileRecordDetails: FileRecordDetails;
    height: number;
}

export const AudioFileRecordLanguagesView = ({
    fileRecordDetails,
    height
}: AudioFileRecordLanguagesViewProps): JSX.Element => {
    ensureAudioFileRecordDetails(fileRecordDetails);

    return (
        <GridRow style={{ height }}>
            <GridColumn sm={12}>
                <LabeledText
                    label="Soundtrack"
                    value={
                        fileRecordDetails.soundtrack ? getLanguageDisplayName(fileRecordDetails.soundtrack) : undefined
                    }
                    testId="file-record-soundtrack-field"
                />
            </GridColumn>
        </GridRow>
    );
};
